import { PacmanLoader } from 'react-spinners';
import styles from './styles.module.scss';

export default function LoadingComponent() {
  return (
    <div id={styles.loadingWrapper}>
        <PacmanLoader color='white' size={30} />
    </div>
  )
}
